import React from 'react';

import useEventTracking from '@hooks/useEventTracking';
import { article_path } from '@routes';
import { ClickTarget, ContentType, TrackingLocation, click } from '@tracking';

import Highlight from '../FeedItems/Highlight';
import TimeAgo from '../TimeAgo';

interface ArticleItemProps {
  highlight: string;
  id: number;
  index: number;
  publishedAt: string;
  slug: string;
  title: string;
}

const ArticleItem = ({ highlight, id, index, publishedAt, slug, title }: ArticleItemProps) => {
  const { Track, trackEvent } = useEventTracking({
    contentId: id,
    contentIndex: index,
    contentType: ContentType.Article,
    location: TrackingLocation.MostPopularArticles,
  });

  return (
    <Track>
      <li className="border-0 border-b border-solid border-grayscale-gray py-24 last:border-b-0">
        {highlight && (
          <Highlight highlight={highlight} className="font-suisse-intl-mono !text-caption-sm" />
        )}
        <a
          href={article_path(slug)}
          onClickCapture={() =>
            trackEvent(click({ clickTarget: ClickTarget.Headline, clickText: title }))
          }
          className="my-8 font-suisse-neue text-body-lg text-black hover:text-primary-magenta"
        >
          {title}
        </a>
        {publishedAt && (
          <TimeAgo
            className="block font-suisse-screen text-grayscale-charcoal"
            date={publishedAt}
          />
        )}
      </li>
    </Track>
  );
};

export default ArticleItem;
